import axiosClient from '@/config/api/axios'
import { VOICE_TOKEN } from '@/config/api/endpoints'

export async function requestVoiceToken(conversationId) {
  const { data } = await axiosClient.post(VOICE_TOKEN, { conversation_id: conversationId })
  if (!data?.token || !data?.url) throw new Error('Voice service returned an invalid room token')
  return data
}
